/**
 * 상담 전화 시간 정책 (콜 부하 감축). 임종 접수는 이 시간 제한을 받지 않는다.
 * 한국 시간 기준 매일 09:00 이상 19:00 미만에만 상담 전화를 연결한다.
 */
export const CONSULT_OPEN_HOUR = 9;
export const CONSULT_CLOSE_HOUR = 19;

const pad = (hour: number) => String(hour).padStart(2, "0");

/** 상담 가능 시간 안내. 예: 상담 가능 시간 09:00~19:00 */
export const CONSULT_HOURS_LABEL = `상담 가능 시간 ${pad(
  CONSULT_OPEN_HOUR
)}:00~${pad(CONSULT_CLOSE_HOUR)}:00`;

/** 시간 외에 비활성 버튼 아래 붙는 안내 문구 */
export const CONSULT_CLOSED_NOTICE = `지금은 임종 접수와 장례 상담만 가능해요.\n${CONSULT_HOURS_LABEL}`;
